import { GlButton } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
export default {
    name: 'EditorModeSwitcher',
    components: {
        GlButton
    },
    props: {
        value: {
            type: String,
            required: true
        }
    },
    emits: [
        'switch'
    ],
    computed: {
        markdownEditorSelected () {
            return this.value === 'markdown';
        },
        text () {
            return this.markdownEditorSelected ? __('Switch to rich text editing') : __('Switch to plain text editing');
        }
    },
    richTextEditorButtonId: 'switch-to-rich-text-editor'
};
